import CN from "classnames";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";

export const Disclaimer = ({
  children,
  title,
  isSmall = false,
  ...restBoxProps
}: React.ComponentProps<typeof Box> & {
  title?: string | React.ReactNode;
  isSmall?: boolean;
}) => (
  <DisclaimerWrapper {...restBoxProps} className={CN(isSmall && "-isSmall")}>
    {!!title && <h3>{title}</h3>}
    {children}
  </DisclaimerWrapper>
);

const DisclaimerWrapper = styled(Box)`
  margin-top: 24px;
  max-width: ${({ theme }) => `${theme.breakpoints.values.sm}px`};
  font-size: 0.9rem;
  color: ${({ theme }) => theme.palette.dream.grayMediumDark};

  &.-isSmall {
    opacity: 0.8;
    font-size: max(0.75rem, 11px);
    line-height: 125%;
  }

  h3 {
    margin-bottom: 0.5rem;
    font-size: 1.2rem;
  }

  &&& p {
    color: ${({ theme }) => theme.palette.dream.grayMediumDark};
  }
`;
